import { Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const ModalAp = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;

  & .muibackdrop-root {
    backdrop-filter: blur(6px);
    background-color: rgba(0, 0, 0, 0.4);
  }
`;

export const ModalTitle = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 8px;
`;
